import { hotelDirectory } from './index';

document.addEventListener('DOMContentLoaded', () => {
  hotelDirectory();
});
